import { Bell } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/components/ui/popover';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import { useTranslation } from 'react-i18next';
import { useNotificationsSlot } from '@/shared/contexts/notifications-slot-context';

export function HeaderNotifications() {
  const { t } = useTranslation('layout');
  const { content, count } = useNotificationsSlot();

  return (
    <Popover>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              aria-label={t('header.notifications.label')}
              className="relative"
            >
              <Bell className="w-5 h-5" />
              {count > 0 && (
                <span
                  data-testid="invitations-notification-badge"
                  className="absolute top-1.5 right-1.5 w-2 h-2 bg-destructive rounded-full ring-2 ring-background"
                />
              )}
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>{t('header.notifications.label')}</TooltipContent>
      </Tooltip>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <span className="text-sm font-semibold">{t('header.notifications.title')}</span>
        </div>
        {content ?? (
          <div className="flex items-center justify-center py-10 text-sm text-muted-foreground">
            {t('header.notifications.empty')}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
